import UserCard, { formatDate } from "./UserCard"
export { formatDate }
export default UserCard
